import { CoreTagsIdMapName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { defaultTagsIdMapState } from './state';
import { RemoveSonarTagRequest } from '@types';

export const coreTagsIdMapRemoveSlice = createRemoveSyncSlice({
	name: CoreTagsIdMapName,
	state: defaultTagsIdMapState,
	transform: (action: RemoveSonarTagRequest, state = {}) => {
		const updatedState: typeof state = {
			...state
		};

		if (state[ action.id ] !== undefined) {
			delete updatedState[ action.id ];
		}

		return updatedState;
	}
});
